import { Helper } from '@viddsee/server-api-client';

type GlobalWithSsrData<T> = {
  __ssr__data__?: {
    data?: T;
  };
}

export const configureSsrData = <T>(): T => {
  const w = (window as Window & typeof globalThis & GlobalWithSsrData<T>);
  // eslint-disable-next-line @typescript-eslint/camelcase
  w.__ssr__data__ = w.__ssr__data__ || {};

  const data = w.__ssr__data__.data;
  const normalilzedData = data ? Helper.convertToCamelCase(data) : {} as T;

  w.__ssr__data__.data = normalilzedData;

  return normalilzedData;
};
